var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"edit-box",style:(_vm.note.length === 0 ? { color: '#da4e4e'} : {}),attrs:{"id":_vm.textEditId,"contenteditable":"true"},domProps:{"innerHTML":_vm._s(_vm.note)},on:{"input":_vm.textEdited}})])
}
var staticRenderFns = []

export { render, staticRenderFns }